/**
 * FormData prototype restoration — verbatim port of the parse-time IIFE at the
 * top of v1 index.js (research/01 §1.1; REQ-BOOT-2). Called from the entry at
 * script-parse time (after module imports, before DOM-ready registration).
 *
 * Bail conditions, hidden-iframe steal, conditional window.FormData
 * replacement and the exact log strings are all load-bearing:
 *   "[CPC] Restored FormData via iframe sandbox"
 *   "[CPC] FormData restore failed:" + e.message
 */
export function cpcRestoreFormData(): void {
  if (typeof FormData === "undefined") return;
  if (typeof (FormData.prototype as any).entries === "function") return;
  try {
    var iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    var TrueNativeFormData = (iframe.contentWindow as any).FormData;
    document.body.removeChild(iframe);
    if (
      TrueNativeFormData &&
      typeof TrueNativeFormData.prototype.entries === "function"
    ) {
      window.FormData = TrueNativeFormData;
      console.log("[CPC] Restored FormData via iframe sandbox");
    }
  } catch (e: any) {
    console.warn("[CPC] FormData restore failed:", e.message);
  }
}
